import React, { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import restService from "../../../../services/restService";
import Input from "../../../../components/common/Input";

const keys = [
  "agent_id",
  "agency_id",
  "company_percentage",
  "agent_percentage",
  "agency_percentage",
];

const UpdateCommissionConfiguration = ({
                                         commission,
                                         onSubmit,
                                         initCallback,
                                         setCommissionToUpdate,
                                       }) => {

  const [form, setForm] = useState({
    agent_id: "",
    agency_id: "",
    agency_percentage: commission.agency_percentage,
    agent_percentage: commission.agent_percentage,
    company_percentage: commission.company_percentage
  });
  const [errors, setErrors] = useState({});
  const [agents, setAgents] = useState([]);
  const [agencies, setAgencies] = useState([]);

  const initFormValues = async () => {
    const agencyList = await restService.AgencyApi.getAgencies();
    const agentList = await restService.AgentApi.getAgentsByAgency(
        agencyList.data?.data?.data[0]?.id
    );
    setAgents(agentList.data?.data?.data || []);
    setAgencies(agencyList.data?.data?.data || []);

    setForm({
      ...form,
      agency_id: commission.agency.id,
      agent_id: commission.agent.id,
    });
  };

  useEffect(() => {
    initFormValues();
  }, []);

  useEffect(() => {
    setForm(prevForm => ({
      ...prevForm,
      company_percentage: 100 - (Number(prevForm.agency_percentage) + Number(prevForm.agent_percentage))
    }));
  }, [form.agency_percentage, form.agent_percentage]);

  const validateForm = () => {
    let errorList = { ...errors };
    keys.forEach((key) => {
      if (form[key] === "" || form[key] === undefined) {
        errorList[key] = "This field is required.";
      }
    });
    if (
        Number(form.agency_percentage) +
        Number(form.agent_percentage) +
        Number(form.company_percentage) !==
        100
    ) {
      errorList.total =
          "Agency, agent, and company Percentage should add up to 100.";
    }
    setErrors(errorList);
    return Object.keys(errorList).length === 0;
  };

  const updateCommission = () => {
    if (validateForm()) {
      restService.CommissionsConfigApi.updateCommissionConfiguration(form, commission?.id).then(
          (response) => {
            onSubmit();
          }
      );
    }
  };

  const onFormChange = ({ target }) => {
    const { name, value } = target;
    let updatedForm = { ...form, [name]: value };
    let errorList = { ...errors };

    if (name === "agency_id") {
      restService.AgentApi.getAgentsByAgency(value).then(({ data }) => {
        setAgents(data?.data.data || []);
        setForm(prevForm => ({ ...updatedForm, agent_id: data?.data?.data[0]?.id }));
      });
      delete errorList["agent_id"];
    }

    setForm(updatedForm);
    delete errorList[name];
    delete errorList.total;
    setErrors(errorList);
  };

  return (
      <div className="flex intro-y flex-col items-center md:gap-8 gap-6 justify-center py-8 px-8">
        {/* Modern Header */}
        <div className="flex items-start justify-between w-full">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-gradient-to-r from-purple-100 to-indigo-100 rounded-xl">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-purple-600">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <div className="flex flex-col gap-1">
              <h1 className="text-2xl font-bold text-gray-900">
                Update Commission Configuration
              </h1>
              <p className="text-sm text-gray-600">
                Modify the commission percentage settings
              </p>
            </div>
          </div>

          <button
              onClick={() => setCommissionToUpdate(undefined)}
              className="p-2 rounded-xl text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all border-none bg-transparent cursor-pointer"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6 6 18" />
              <path d="M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="grid w-full md:max-w-[80%] md:grid-cols-2 gap-4 grid-cols-1">
          <Input
              containerStyle={"w-full md:w-auto"}
              type="number"
              min={0}
              max={100}
              value={form.agency_percentage}
              onChange={onFormChange}
              name="agency_percentage"
              className="form-control"
              placeholder="43.20"
              labelName={"  Agency Percentage * *"}
          />
          <Input
              containerStyle={"w-full md:w-auto"}
              type="number"
              min={0}
              max={100}
              value={form.agent_percentage}
              onChange={onFormChange}
              name="agent_percentage"
              className="form-control"
              placeholder="43.20"
              labelName={" Agent Percentage *"}
          />

          <Input
              containerStyle={"w-full md:w-auto"}
              type="number"
              min={0}
              max={100}
              value={form.company_percentage}
              onChange={onFormChange}
              name="company_percentage"
              className="form-control"
              placeholder="13.20"
              labelName={" Company Percentage *"}
          />
          <div className="flex flex-col gap-1">
            <label htmlFor="input-wizard-5" className="form-label mb-0 text-xs">
              Agency *
            </label>
            <select
                id="custom-form-select"
                value={form.agency_id}
                onChange={onFormChange}
                name="agency_id"
                className="form-select"
            >
              {agencies.map((agency) => (
                  <option key={agency.id} value={agency.id}>
                    {agency.name}
                  </option>
              ))}
            </select>
            <p className="text-red-500 text-xs italic pt-1">{errors.agency_id}</p>
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="input-wizard-5" className="form-label mb-0 text-xs">
              Agent *
            </label>
            <select
                id="custom-form-select"
                value={form.agent_id}
                onChange={onFormChange}
                name="agent_id"
            >
              {agents.map((agent) => (
                  <option key={agent.id} value={agent.id}>
                    {agent.firstname} {agent.lastname}
                  </option>
              ))}
            </select>
            <p className="text-red-500 text-xs italic pt-1 text-center">
              {errors.agent_id}
            </p>
          </div>
        </div>

        {/* Modern Action Buttons */}
        <div className="flex items-center gap-4">
          <button
              onClick={() => setCommissionToUpdate(undefined)}
              className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 shadow-md flex items-center gap-2"
          >
            Cancel
          </button>
          <button
              onClick={() => updateCommission()}
              className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border-none bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:from-purple-700 hover:to-indigo-700 shadow-lg flex items-center gap-2"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <path d="M22 4 12 14.01l-3-3" />
            </svg>
            Update Commission
          </button>
        </div>
      </div>
  );
};

export default UpdateCommissionConfiguration;
